import useGetReminders from "../../reminders/api/useGetReminders";

export default function useGetTopicReminders(topicId: string, is_completed?: boolean) {
  return useGetReminders(
    { subject_id: topicId, is_completed },
    !!topicId
  );
}
